var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-backtop',{attrs:{"target":"","visibility-height":100}},[_c('div',{staticClass:"backPageTop tc"},[_c('i',{staticClass:"el-icon-arrow-up"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }